import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { logofrop } from "../assets/img/img";
import navIcon3 from "../assets/img/behance.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import {
  BrowserRouter as Router
} from "react-router-dom";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (

    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand className="logofrop" href="/#">
            <img src={logofrop} alt="frop foundation" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {/**<Nav.Link href="/#" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Início</Nav.Link>
              <Nav.Link href="#about" className={activeLink === 'about' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('about')}>Sobre</Nav.Link>**/}
              <Nav.Link className={activeLink === 'behance' ? 'active navbar-link' : 'navbar-link'}>Portfólio & Contato →</Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href="#"><img src={navIcon3} alt="" /></a>
                <a href="https://github.com/imfrop"><img src={navIcon1} alt="" /></a>
                <a href="mailto:leduardo@frop.info"><img src={navIcon2} alt="" /></a>
              </div>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  )
}